module.exports = [
  {
    title: 'Ремонт электрики',
    info:
      'Электрика в автомобиле это одна из важнейших частей которая требует ухода и качественного ремонта. Некачественные соединения проводки могут вызвать неисправность остальных узлов. Короткое замыкание может привести к непредвиденным результатам, от выхода из строя датчиков и блока управления до пожара. Мы вас предостерегаем, без должного уровня не стоит самому заниматься ремонтом электрической части автомобилей.',
    items: [
      {
        title: 'Ремонт генератора/стартера',
        info: 'Ремонт генератора происходит в несколько этапов:',
        list: [
          'демонтаж генератора/стартера',
          'дефектовка генератора/стартера',
          'непосредственно ремонт генератора/стартера',
          'замена подшипников, замена щеток',
          'монтаж генератора/стартера'
        ]
      },
      {
        title: 'Общие работы по электрике',
        info: 'В общие работы по электрике входит:',
        list: [
          'ремонт/замена систем охлаждения, радиаторов',
          'ремонт печи',
          'ремонт проводки',
          'ремонт блока предохранителей',
          'ремонт/замена блока реле'
        ]
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/data/electric.js